export default "__VITE_ASSET__CA0cuMP7__"